import type { ComponentType, ReactNode } from "react";
import { Linking, Text } from "react-native";
import { markdownToBlocks, type Inline } from "../markdown-lite";

export type RichTextNativeProps = {
  markdown: string;
  /** Renders one paragraph or bullet line; receives the inline runs as children. */
  Paragraph: ComponentType<{ children: ReactNode }>;
  linkColor?: string;
};

function Runs({ runs, linkColor }: { runs: Inline[]; linkColor?: string }) {
  return (
    <>
      {runs.map((run, index) => (
        <Text
          key={index}
          style={{
            fontWeight: run.bold ? "700" : undefined,
            fontStyle: run.italic ? "italic" : undefined,
            textDecorationLine: run.href ? "underline" : undefined,
            color: run.href ? linkColor : undefined,
          }}
          onPress={run.href ? () => void Linking.openURL(run.href!) : undefined}
        >
          {run.text}
        </Text>
      ))}
    </>
  );
}

/** The description/instructions markdown subset on React Native. Text styling
 *  comes from the host's Paragraph component; marks nest inside it. */
export function RichText({
  markdown,
  Paragraph,
  linkColor,
}: RichTextNativeProps) {
  const blocks = markdownToBlocks(markdown);
  return (
    <>
      {blocks.map((block, index) =>
        block.type === "paragraph" ? (
          <Paragraph key={index}>
            <Runs runs={block.inlines} linkColor={linkColor} />
          </Paragraph>
        ) : (
          block.items.map((item, i) => (
            <Paragraph key={`${index}-${i}`}>
              {"• "}
              <Runs runs={item} linkColor={linkColor} />
            </Paragraph>
          ))
        ),
      )}
    </>
  );
}
